export type InteractiveItemOptions = {
  id: string;
  radius?: number;
  onCollect?: () => void;
};

export class InteractiveItem {
  public readonly id: string;
  public readonly radius: number;
  private readonly onCollect?: () => void;
  private collected: boolean;

  constructor({ id, radius = 5, onCollect }: InteractiveItemOptions) {
    this.id = id;
    this.radius = radius;
    this.onCollect = onCollect;
    this.collected = false;
  }

  public updateDistance(distance: number): boolean {
    if (this.collected) return false;
    if (!Number.isFinite(distance)) return false;

    if (distance <= this.radius) {
      this.collected = true;
      if (this.onCollect) {
        this.onCollect();
      }
      return true;
    }

    return false;
  }

  public isCollected(): boolean {
    return this.collected;
  }

  public dispose() {
    // Placeholder for future resource cleanup if needed.
  }
}
